import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faArrowCircleDown} from '@fortawesome/pro-solid-svg-icons';
import {canCreatePdfFromSavedSearch} from '../enablers';
import {SEARCH_SAVED_ACTION_LABELS} from '../locales';
import {type SavedSearch} from '../types';
import {SEARCH_SAVED_EVENT} from './constants';

export const searchSavedActionCreatePDFDownloadIcon = faArrowCircleDown;

/**
 * Create and download pdf from saved search assets
 * @param params
 * @returns Action
 */
export const searchSavedActionCreatePDFDownload = (
	savedSearch?: SavedSearch,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'saved-search-create-pdf-download',
	cb: () =>
		dispatcher.trigger(SEARCH_SAVED_EVENT.CREATE_PDF_DOWNLOAD, savedSearch),
	enableTest: () => canCreatePdfFromSavedSearch(savedSearch),
	icon: searchSavedActionCreatePDFDownloadIcon,
	get label() {
		return SEARCH_SAVED_ACTION_LABELS.CREATE_PDF_DOWNLOAD;
	},
	...params,
});

export default searchSavedActionCreatePDFDownload;
